export enum AdminPharmacistsTableColumnDataIndex {
  FirstName = "firstName",
  LastName = "lastName",
  Email = "email",
  Active = "active",
  Options = "options",
}
